<!-- 视频弹窗 -->
<!-- 这里使用 v-if 是用来解决 dialog 关闭后视频会继续播放的问题 -->
<template>

  <!-- 弹出窗 开始 -->
  <el-dialog
    v-if="dialogVisible"
    :visible="dialogVisible"
    width="800px"
    custom-class="component-video-dialog"
    top="20vh"
    @close="dialogVisible = false"
  >

    <!-- 自定义弹出窗内容区域 开始 -->
    <div class="video-dialog-wrapper">

      <!-- 视频 -->
      <video :poster="videoPoster" width="800" height="450" style="display: block; margin-left: auto; margin-right: auto;" controls autoplay>
        <source :src="videoSrc" type="video/mp4">
        <source :src="videoSrc" type="video/ogg">
        <source :src="videoSrc" type="video/webm">
        <object :data="videoSrc" width="800" height="450" type="application/x-shockwave-flash">
          <param :value="videoSrc" name="movie" >
          <param :value="'autostart=true&amp;file='+videoSrc" name="flashvars" >
        </object>
        当前浏览器不支持 video直接播放，点击这里下载视频： <a :href="videoSrc">下载视频</a>
      </video>

      <!-- 关闭按钮 -->
      <i class="el-icon-circle-close close-btn-icon" @click="dialogVisible = false"/>

    </div>
    <!-- 自定义弹出窗内容区域 结束 -->

  </el-dialog>
  <!-- 弹出窗 结束 -->

</template>

<script>
export default {
  name: 'ComponentVideoDialog',
  data() {
    return {
      dialogVisible: false, // 对话框显示状态
      videoSrc: '', // 视频地址
      videoPoster: '' // 视频封面图地址
    }
  },
  methods: {
    /**
       * ##########################################################################################
       * @description 显示对话框
       * @param {String} videoSrc   : 视频文件地址
       * @param {String} videoPoster: 视频封面图地址
       * ##########################################################################################
       */
    show(videoSrc, videoPoster) {
      console.log('视频地址：', videoSrc)
      console.log('视频封面图地址：', videoPoster)
      this.videoSrc = videoSrc || ''
      this.videoPoster = videoPoster || ''
      this.dialogVisible = true
    }
  }
}
</script>

<!-- 覆盖ElementUI样式 -->
<style type="text/css">
  .component-video-dialog.el-dialog {
    border-radius: 10px;
  }
  .component-video-dialog .el-dialog__header {
    display: none;
  }
  .component-video-dialog .el-dialog__body {
    padding: 0;
    border-radius: 10px;
  }
</style>

<!-- 组件独有样式 -->
<style scoped>
  .video-dialog-wrapper {
    background-color: #000000;
    position: relative;
  }

  .close-btn-icon {
    position: absolute;
    z-index: 10;
    bottom: -76px;
    color: #FFFFFF;
    left: 50%;
    font-size: 34px;
    font-weight: 400;
    transform: translateX(-50%);
    transition: all 0.4s;
    cursor: pointer;
  }

  .close-btn-icon:hover {
    opacity: 0.6;
  }

</style>



// WEBPACK FOOTER //
// src/components/video-dialog.vue